import { action, makeAutoObservable, observable } from "mobx";

class ContactSelectionModalStore {
  selectedIds?: string[];
  onSave?: (selectedIds: string[]) => void;

  constructor() {
    makeAutoObservable(this, {
      selectedIds: observable,
      onSave: observable,
      closeModal: action,
    });
  }

  public closeModal = () => {
    this.selectedIds = undefined;
    this.onSave = undefined;
  };

  public setContactParams = (
    selectedIds: string[],
    onSave: (selectedIds: string[]) => void
  ) => {
    this.selectedIds = selectedIds;
    this.onSave = onSave;
  };
}

export default new ContactSelectionModalStore();
